import { templatesMatchingPageFormat } from './types';
import type { PageFormat, PresentationCatalog, PresentationTemplate } from './types';

export function catalogPageFormat(catalog: PresentationCatalog): PageFormat {
  return catalog === 'salesSheets' ? 'a4_portrait' : 'widescreen_16_9';
}

export function catalogCategoryKind(catalog: PresentationCatalog): 'presentation' | 'salesSheet' {
  return catalog === 'salesSheets' ? 'salesSheet' : 'presentation';
}

export function templatesForCatalog<T extends { pageFormat?: PageFormat | string | null }>(
  templates: T[],
  catalog: PresentationCatalog,
): T[] {
  return templatesMatchingPageFormat(templates, catalogPageFormat(catalog));
}

export function preferredCreateTemplateId(
  templates: Array<Pick<PresentationTemplate, '_id' | 'name' | 'pageFormat'>>,
  catalog: PresentationCatalog,
): string {
  const matching = templatesForCatalog(templates, catalog);
  if (catalog === 'salesSheets') {
    const named = matching.find((template) => template.name === 'Aviseringsblad');
    if (named) return named._id;
  }
  return matching[0]?._id || '';
}
